import { useHistory } from "react-router-dom";

/**
 * For 99% of cases, we don't care about anything but history.push.
 * To make code cleaner and closures easier to write, we export this
 * function as a standalone.
 */
export function usePush(): (to: string) => void {
  return useHistory().push;
}
